import addToBasketReducer from 'reducers/addToBasket';

const { ACTION_TYPES } = addToBasketReducer;

function resetBasket() {
    return dispatch => {
        dispatch({
            type: ACTION_TYPES.RESET_BASKET
        });
    };
}

export { resetBasket };
